export var VIDEO_EXERCISE = 'VideoExercise';
export var EXPORTED_EXERCISES = [VIDEO_EXERCISE];